import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AppConsts {
    public sessionProjectID = 'ProjectID';
    public sessionServiceID = 'ServiceID';
    public pageRecord = 50;
}